/**
 * Testimonials — IO stagger reveal only.
 */

import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

class TestimonialsComponent extends Component {
  #io = null;

  connectedCallback() {
    super.connectedCallback();
    const reveals = this.querySelectorAll('.reveal');
    if (prefersReducedMotion()) {
      reveals.forEach((el) => el.classList.add('is-visible'));
    } else {
      this.#io = new IntersectionObserver((entries) => {
        for (const e of entries) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); this.#io?.unobserve(e.target); }
        }
      }, { rootMargin: '0px 0px -10% 0px' });
      reveals.forEach((el) => this.#io.observe(el));
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#io?.disconnect();
  }
}

if (!customElements.get('testimonials-component')) {
  customElements.define('testimonials-component', TestimonialsComponent);
}
